import { KOCH_SWIPER_A11Y } from '../../scripts/swiper-defaults';

export function initTimelineSliders() {
    const sections = document.querySelectorAll('[data-redesign-section="section_timeline"]');
    if (!sections.length || typeof Swiper === 'undefined') {
        return;
    }

    sections.forEach((section) => {
        const textEl = section.querySelector('[data-koch-timeline-text]');
        if (!textEl || textEl.swiper) {
            return;
        }

        const mediaEl = section.querySelector('[data-koch-timeline-media]');
        const prev = section.querySelector('.koch-timeline__arrow--prev');
        const next = section.querySelector('.koch-timeline__arrow--next');

        let mediaSwiper = null;
        if (mediaEl && !mediaEl.swiper) {
            mediaSwiper = new Swiper(mediaEl, {
                a11y: KOCH_SWIPER_A11Y,
                slidesPerView: 1,
                spaceBetween: 0,
                loop: false,
                allowTouchMove: false,
            });
        }

        const textSwiper = new Swiper(textEl, {
            a11y: KOCH_SWIPER_A11Y,
            slidesPerView: 1,
            spaceBetween: 24,
            loop: false,
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
        });

        if (mediaSwiper) {
            textSwiper.controller.control = mediaSwiper;
            mediaSwiper.controller.control = textSwiper;
        }
    });
}
